import { render, staticRenderFns } from "./SactinClients.vue?vue&type=template&id=2d48b793&scoped=true&"
import script from "./SactinClients.vue?vue&type=script&lang=js&"
export * from "./SactinClients.vue?vue&type=script&lang=js&"
import style0 from "./SactinClients.vue?vue&type=style&index=0&id=2d48b793&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48b793",
  null
  
)

export default component.exports